export const ajaxurl = "/wp-admin/admin-ajax.php";

export function createElementAnd(name, fn) {
    const el = document.createElement(name);

    if (fn)
        fn(el);

    return el;
}

export function degreesToRadians(degrees) {
    return degrees * (Math.PI / 180);
}

export function dmy(date) {
    date = date || new Date();

    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    month = month > 9 ? month : '0' + month;
    day = day > 9 ? day : '0' + day;

    return `${day}-${month}-${year}`;
}

export function getDistanceInKM(pointA, pointB) {
    let lat1 = pointA.lat;
    let lat2 = pointB.lat;
    let lng1 = pointA.lng;
    let lng2 = pointB.lng;
    let R = 6371;
    let dLat = degreesToRadians(lat2 - lat1);
    let dLng = degreesToRadians(lng2 - lng1);
    let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(degreesToRadians(lat1)) * Math.cos(degreesToRadians(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
}

export function isInViewport(elm) {
    const {top, left, right, bottom} = elm.getBoundingClientRect();

    return (
        top < (window.innerHeight || document.documentElement.clientHeight) &&
        left < (window.innerWidth || document.documentElement.clientWidth) &&
        right > 0 &&
        bottom > 0
    );
}

export function raf(fn) {
    if ("requestAnimationFrame" in window)
        requestAnimationFrame(fn);
    else
        setTimeout(fn, 0);
}
